import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const HERO = "https://images.unsplash.com/photo-1610664921890-ebad05086414?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHx1c2VkJTIwZWxlY3Ryb25pY3MlMjBsYXB0b3AlMjBzbWFydHBob25lfGVufDB8fHx8MTc4NzU2MDY2OHww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate({ administrator: "/", admin: "/pembelian", kasir: "/penjualan", audit: "/laporan" }[u.role] || "/penjualan");
    } catch (err) {
      setError(errMsg(err, "Gagal masuk. Periksa email dan kata sandi."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-white">
      <div className="hidden lg:block relative w-1/2">
        <img src={HERO} alt="Elektronik bekas" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/60 flex flex-col justify-end p-10">
          <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-white/70">Sistem Kasir & Stok</p>
          <h1 className="mt-2 text-3xl font-bold text-white tracking-tight" style={{ fontFamily: "'Work Sans', sans-serif" }}>Kelola jual beli barang elektronik bekas dari satu aplikasi.</h1>
          <p className="mt-3 text-sm text-white/80 max-w-md">Pembelian, stok per unit, penjualan, neraca, dan laba rugi — semua tercatat rapi dan bisa dibuka dari handphone.</p>
        </div>
      </div>
      <div className="flex w-full lg:w-1/2 items-center justify-center px-6 py-10">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary text-white font-bold" style={{ fontFamily: "'Work Sans', sans-serif" }}>GE</div>
          <h2 className="mt-4 text-2xl font-bold tracking-tight" style={{ fontFamily: "'Work Sans', sans-serif" }}>Masuk ke Akun</h2>
          <p className="mt-1 text-sm text-muted-foreground">Griya Elektronik — Jual Beli Barang Bekas</p>
          {error && <div className="mt-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</div>}
          <div className="mt-6 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nama@email.com" data-testid="login-email-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Kata Sandi</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password-input" />
            </div>
            <Button type="submit" className="w-full rounded-full active:scale-95 transition-transform duration-100" disabled={loading} data-testid="login-submit-button">
              {loading ? "Memproses..." : "Masuk"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
